// extracted by mini-css-extract-plugin
export default {"cardContainer":"ProductSection_cardContainer__lJKrC"};